const startProductSwatches = () => {
  if (window.__productVariantSwatchesStarted === true) return;
  window.__productVariantSwatchesStarted = true;

  let section = document.querySelector('[data-product-variant-swatches]');
  const variantsScript = document.querySelector(
    '[data-product-variant-swatches-variants]'
  );
  const optionsScript = document.querySelector(
    '[data-product-variant-swatches-options]'
  );

  if (!section || !section.matches('[data-product-variant-swatches]')) {
    window.__productVariantSwatchesStarted = false;
    return false;
  }

  const isDesignMode = Boolean(
    window.Shopify && window.Shopify.designMode
  );

  const currentProductId = String(
    section.getAttribute('data-product-id') || ''
  ).trim();

  const currentProductHandle = String(
    section.getAttribute('data-product-handle') || ''
  ).trim();

  const normalize = (value) => {
    return String(value || '').trim().toLowerCase();
  };

  const escapeHtml = (value) => {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  const parseCsv = (value) => {
    return String(value || '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  };

  const getPixelSize = (value, fallback) => {
    const parsed = Number.parseInt(String(value || ''), 10);

    if (!Number.isFinite(parsed)) {
      return fallback;
    }

    return Math.max(12, Math.min(parsed, 138));
  };

  const stableListSignature = (items) => {
    return [...new Set((items || []).map(normalize).filter(Boolean))]
      .sort()
      .join(',');
  };

  const getSwatchSignature = (swatch) => {
    return [
      normalize(swatch.label),
      normalize(swatch.productRule),
      stableListSignature(swatch.productIds),
      stableListSignature(swatch.productHandles)
    ].join('|');
  };

  let variants = [];
  let optionNames = [];
  let activeGroups = [];
  let customizerReapplyQueued = false;
  let productTitleUpdateQueued = false;
  let resizeQueued = false;

  try {
    variants = variantsScript
      ? JSON.parse(variantsScript.textContent || '[]')
      : [];

    optionNames = optionsScript
      ? JSON.parse(optionsScript.textContent || '[]')
      : [];
  } catch (error) {
    console.error(
      'Product variant swatch data failed to parse:',
      error
    );
  }

  const getColorBackground = (colors, style = 'line') => {
    if (!Array.isArray(colors) || !colors.length) {
      return '#f3f3f3';
    }

    if (colors.length === 1) {
      return colors[0];
    }

    const segmentSize = 100 / colors.length;

    const stops = colors.flatMap((color, index) => {
      const start = segmentSize * index;
      const end = segmentSize * (index + 1);

      return [
        `${color} ${start}%`,
        `${color} ${end}%`
      ];
    });

    if (style === 'conic') {
      return `conic-gradient(from -90deg, ${stops.join(', ')})`;
    }

    return colors[0];
  };

  const productRuleApplies = (
    swatch,
    productId = currentProductId,
    productHandle = currentProductHandle
  ) => {
    const productRule = swatch.productRule || 'exclude';
    const productIds = swatch.productIds || [];
    const productHandles = swatch.productHandles || [];

    const hasSelectedProducts =
      productIds.length || productHandles.length;

    const matchesProduct =
      productIds.some(
        (id) => String(id) === String(productId)
      ) ||
      productHandles.some(
        (handle) =>
          normalize(handle) === normalize(productHandle)
      );

    if (productRule === 'include') {
      return hasSelectedProducts && matchesProduct;
    }

    return !matchesProduct;
  };

  const getSwatches = (
    productId = currentProductId,
    productHandle = currentProductHandle
  ) => {
    const groupsByOptionName = new Map();

    section
      .querySelectorAll('[data-product-swatch-group]')
      .forEach((groupEl) => {
        const optionName =
          groupEl.getAttribute('data-option-name');

        if (!optionName) return;

        const optionKey = normalize(optionName);

        if (!groupsByOptionName.has(optionKey)) {
          groupsByOptionName.set(optionKey, {
            optionName,
            productSwatchSize: 40,
            collectionSwatchSize: 34,
            rolloverPreview: false,
            labelPopup: false,
            swatchPreview: false,
            showOnCard: false,
            swatchesBySignature: new Map()
          });
        }

        const group = groupsByOptionName.get(optionKey);

        group.optionName = optionName;

        group.productSwatchSize = getPixelSize(
          groupEl.getAttribute('data-product-swatch-size'),
          40
        );

        group.collectionSwatchSize = getPixelSize(
          groupEl.getAttribute('data-collection-swatch-size'),
          34
        );

        group.rolloverPreview =
          groupEl.getAttribute('data-rollover-preview') ===
          'true';

        group.labelPopup =
          groupEl.getAttribute('data-label-popup') ===
          'true';

        group.swatchPreview =
          groupEl.getAttribute('data-swatch-preview') ===
          'true';

        group.showOnCard =
          groupEl.getAttribute('data-show-on-card') ===
          'true';

        groupEl
          .querySelectorAll('[data-product-swatch]')
          .forEach((swatchEl) => {
            const label =
              swatchEl.getAttribute('data-option-value');

            const image =
              swatchEl.getAttribute('data-swatch-image');

            const style =
              swatchEl.getAttribute('data-swatch-style') ||
              'line';

            const productRule =
              swatchEl.getAttribute('data-product-rule') ||
              'exclude';

            const productIds = parseCsv(
              swatchEl.getAttribute('data-product-ids')
            );

            const productHandles = parseCsv(
              swatchEl.getAttribute('data-product-handles')
            );

            const colors = [
              swatchEl.getAttribute('data-swatch-color-1'),
              swatchEl.getAttribute('data-swatch-color-2'),
              swatchEl.getAttribute('data-swatch-color-3'),
              swatchEl.getAttribute('data-swatch-color-4'),
              swatchEl.getAttribute('data-swatch-color-5')
            ].filter(Boolean);

            if (
              !label ||
              (!colors.length && !image)
            ) {
              return;
            }

            const swatch = {
              label,
              image,
              colors,
              style,
              productRule,
              productIds,
              productHandles
            };

            group.swatchesBySignature.set(
              getSwatchSignature(swatch),
              swatch
            );
          });
      });

    return [...groupsByOptionName.values()].map(
      (group) => {
        const visibleSwatchesByLabel = new Map();

        [...group.swatchesBySignature.values()].forEach(
          (swatch) => {
            if (
              !productRuleApplies(
                swatch,
                productId,
                productHandle
              )
            ) {
              return;
            }

            visibleSwatchesByLabel.set(
              normalize(swatch.label),
              swatch
            );
          }
        );

        return {
          optionName: group.optionName,
          productSwatchSize: group.productSwatchSize,
          collectionSwatchSize:
            group.collectionSwatchSize,
          rolloverPreview: group.rolloverPreview,
          labelPopup: group.labelPopup,
          swatchPreview: group.swatchPreview,
          showOnCard: group.showOnCard,
          swatches: [...visibleSwatchesByLabel.values()]
        };
      }
    );
  };

  const refreshSectionReference = () => {
    const nextSection = document.querySelector(
      '[data-product-variant-swatches]'
    );

    if (!nextSection) return false;

    section = nextSection;
    return true;
  };

  const refreshActiveGroups = () => {
    activeGroups = getSwatches(
      currentProductId,
      currentProductHandle
    );

    return activeGroups;
  };

  const getProductTitleElement = () => {
    return (
      document.querySelector(
        'main [id^="ProductInfo-template--"][id$="__main"] .product__title > h1'
      ) ||
      document.querySelector(
        '[id^="ProductInfo-"] .product__title h2'
      ) ||
      document.querySelector(
        'main .product__info-container .product__title > h1'
      )
    );
  };

  const getTitleSwatchGroup = () => {
    return (
      activeGroups.find((group) => {
        return /(style|print|pattern|color|colour)/i.test(
          String(group.optionName || '').trim()
        );
      }) ||
      activeGroups[0] ||
      null
    );
  };

  const getSelectedValueForGroup = (group) => {
    if (!group) return '';

    const labels = document.querySelectorAll(
      '[data-product-swatch-label][data-option-name]'
    );

    for (const label of labels) {
      const optionName =
        label.getAttribute('data-option-name');

      if (
        normalize(optionName) !==
        normalize(group.optionName)
      ) {
        continue;
      }

      const fieldset = label.closest('fieldset');

      const checkedInput = fieldset?.querySelector(
        'input[type="radio"]:checked'
      );

      return String(
        checkedInput?.value || ''
      ).trim();
    }

    return '';
  };

  const updateProductTitleFromSelectedSwatch = () => {
    const title = getProductTitleElement();
    if (!title) return;

    if (!title.dataset.productSwatchBaseTitle) {
      title.dataset.productSwatchBaseTitle =
        title.textContent.trim();
    }

    const baseTitle =
      title.dataset.productSwatchBaseTitle;

    const selectedValue = getSelectedValueForGroup(
      getTitleSwatchGroup()
    );

    title.textContent = selectedValue
      ? `${baseTitle} - ${selectedValue}`
      : baseTitle;
  };

  const scheduleProductTitleUpdate = () => {
    if (productTitleUpdateQueued) return;

    productTitleUpdateQueued = true;

    requestAnimationFrame(() => {
      productTitleUpdateQueued = false;
      updateProductTitleFromSelectedSwatch();
    });
  };

  const getCurrentSelections = () => {
    const selections = {};

    document
      .querySelectorAll('[data-product-swatch-label]')
      .forEach((label) => {
        const optionName =
          label.getAttribute('data-option-name');

        if (
          !optionName ||
          selections[optionName]
        ) {
          return;
        }

        const fieldset = label.closest('fieldset');
        if (!fieldset) return;

        const checkedInput = fieldset.querySelector(
          'input[type="radio"]:checked'
        );

        if (!checkedInput) return;

        selections[optionName] =
          checkedInput.value;
      });

    return selections;
  };

  const getVariantImageForOption = (
    optionName,
    optionValue
  ) => {
    if (
      !Array.isArray(variants) ||
      !variants.length
    ) {
      return null;
    }

    const optionIndex = optionNames.findIndex(
      (name) =>
        normalize(name) === normalize(optionName)
    );

    if (optionIndex < 0) return null;

    const selections = getCurrentSelections();
    selections[optionName] = optionValue;

    const exactMatch = variants.find((variant) => {
      return optionNames.every((name, index) => {
        const expectedValue = selections[name];

        if (!expectedValue) {
          return true;
        }

        return (
          normalize(variant.options[index]) ===
          normalize(expectedValue)
        );
      });
    });

    if (exactMatch && exactMatch.image) {
      return exactMatch.image;
    }

    const looseMatch = variants.find((variant) => {
      return (
        normalize(variant.options[optionIndex]) ===
          normalize(optionValue) &&
        variant.image
      );
    });

    return looseMatch
      ? looseMatch.image
      : null;
  };

  const ensurePreview = () => {
    let preview = document.querySelector(
      '[data-product-variant-swatch-preview]'
    );

    if (preview) return preview;

    preview = document.createElement('div');

    preview.className =
      'product-variant-swatch-preview';

    preview.setAttribute(
      'data-product-variant-swatch-preview',
      ''
    );

    preview.innerHTML = `
      <div
        class="product-variant-swatch-preview__visual"
        data-preview-visual
      ></div>
      <div
        class="product-variant-swatch-preview__label"
        data-preview-label
      ></div>
    `;

    document.body.appendChild(preview);

    return preview;
  };

  const renderPreviewVisual = (
    preview,
    visual
  ) => {
    const visualEl = preview.querySelector(
      '[data-preview-visual]'
    );

    if (!visualEl) return false;

    visualEl.classList.remove('is-visible');
    visualEl.innerHTML = '';

    visualEl.style.removeProperty(
      '--preview-swatch-background'
    );

    if (!visual) return false;

    if (
      visual.type === 'image' &&
      visual.image
    ) {
      visualEl.innerHTML = `
        <img
          class="product-variant-swatch-preview__image"
          src="${visual.image}"
          alt=""
        >
      `;

      visualEl.classList.add('is-visible');
      return true;
    }

    if (
      visual.type === 'swatch' &&
      Array.isArray(visual.colors) &&
      visual.colors.length
    ) {
      if (visual.style === 'conic') {
        visualEl.innerHTML = `
          <div
            class="product-variant-swatch-preview__swatch"
            style="
              --preview-swatch-background:
              ${getColorBackground(
                visual.colors,
                visual.style
              )};
            "
          ></div>
        `;
      } else {
        const segments = visual.colors
          .map(
            (color) => `
              <span
                class="product-form__swatch-segment"
                style="background: ${color};"
              ></span>
            `
          )
          .join('');

        visualEl.innerHTML = `
          <div
            class="product-variant-swatch-preview__swatch"
          >
            ${segments}
          </div>
        `;
      }

      visualEl.classList.add('is-visible');
      return true;
    }

    return false;
  };

  const showPreview = (label, options) => {
    const preview = ensurePreview();

    const labelEl = preview.querySelector(
      '[data-preview-label]'
    );

    const hasVisual = renderPreviewVisual(
      preview,
      options.visual
    );

    if (labelEl) {
      if (options.label) {
        labelEl.textContent = options.label;
        labelEl.classList.add('is-visible');
      } else {
        labelEl.textContent = '';
        labelEl.classList.remove('is-visible');
      }
    }

    if (!hasVisual && !options.label) return;

    const rect = label.getBoundingClientRect();

    preview.style.transform =
      'translate3d(0, 0, 0)';

    const previewWidth =
      preview.offsetWidth || 120;

    const previewHeight =
      preview.offsetHeight || 120;

    const gap = 12;

    let left =
      rect.left +
      rect.width / 2 -
      previewWidth / 2;

    let top =
      rect.top -
      previewHeight -
      gap;

    left = Math.max(
      8,
      Math.min(
        left,
        window.innerWidth -
          previewWidth -
          8
      )
    );

    if (top < 8) {
      top = rect.bottom + gap;
      preview.classList.add('is-below');
    } else {
      preview.classList.remove('is-below');
    }

    preview.style.transform = `
      translate3d(
        ${Math.round(left)}px,
        ${Math.round(top)}px,
        0
      )
    `;

    preview.classList.add('is-visible');
  };

  const hidePreview = () => {
    const preview = document.querySelector(
      '[data-product-variant-swatch-preview]'
    );

    if (!preview) return;

    preview.classList.remove('is-visible');

    preview.style.transform =
      'translate3d(-9999px, -9999px, 0)';
  };

  const getPreviewOptions = (
    label,
    group,
    swatch
  ) => {
    const optionName =
      label.getAttribute('data-option-name');

    const optionValue =
      label.getAttribute('data-option-value');

    let visual = null;

    if (group.swatchPreview && swatch) {
      if (swatch.image) {
        visual = {
          type: 'image',
          image: swatch.image
        };
      } else if (
        swatch.colors &&
        swatch.colors.length
      ) {
        visual = {
          type: 'swatch',
          colors: swatch.colors,
          style: swatch.style
        };
      }
    } else if (group.rolloverPreview) {
      const variantImage =
        getVariantImageForOption(
          optionName,
          optionValue
        );

      if (variantImage) {
        visual = {
          type: 'image',
          image: variantImage
        };
      }
    }

    return {
      visual,
      label: group.labelPopup
        ? optionValue
        : ''
    };
  };

  const getProductHandleFromUrl = (
    productUrl
  ) => {
    if (!productUrl) return '';

    try {
      const url = new URL(
        productUrl,
        window.location.origin
      );

      const match = url.pathname.match(
        /\/products\/([^/?#]+)/
      );

      return match
        ? decodeURIComponent(match[1])
        : '';
    } catch (error) {
      return '';
    }
  };

  const getGroupAndSwatchForLabel = (
    label
  ) => {
    const optionName =
      label.getAttribute('data-option-name');

    const optionValue =
      label.getAttribute('data-option-value');

    const quickAddModal =
      label.closest('quick-add-modal');

    const storedProductId =
  quickAddModal
    ? quickAddModal.getAttribute(
        'data-product-swatch-product-id'
      ) || ''
    : '';

const storedProductHandle =
  quickAddModal
    ? quickAddModal.getAttribute(
        'data-product-swatch-product-handle'
      ) || ''
    : '';

const productUrl = quickAddModal
  ? quickAddModal
      .closest(
        '.card-wrapper, li, .grid__item'
      )
      ?.querySelector('[data-product-url]')
      ?.getAttribute('data-product-url') ||
    ''
  : '';

const productHandle =
  storedProductHandle ||
  getProductHandleFromUrl(productUrl);

const groups = quickAddModal
  ? getSwatches(
      storedProductId,
      productHandle
    )
  : activeGroups;

    const group = groups.find(
      (item) =>
        normalize(item.optionName) ===
        normalize(optionName)
    );

    if (!group) {
      return {
        group: null,
        swatch: null
      };
    }

    const swatch = group.swatches.find(
      (item) =>
        normalize(item.label) ===
        normalize(optionValue)
    );

    return {
      group,
      swatch
    };
  };

  const storeOriginalLabel = (
    label,
    optionValue
  ) => {
    if (
      !label.dataset.productSwatchOriginalHtml
    ) {
      label.dataset.productSwatchOriginalHtml =
        label.innerHTML;
    }

    if (
      !label.dataset.productSwatchOriginalValue
    ) {
      label.dataset.productSwatchOriginalValue =
        optionValue ||
        label.textContent.trim() ||
        '';
    }
  };

  const restoreOriginalLabel = (
    label,
    optionValue
  ) => {
    label.dataset.productSwatchUpgraded =
      'false';

    label.classList.remove(
      'product-form__swatch-label',
      'product-form__swatch-label--visual-only'
    );

    label.style.removeProperty(
      '--product-swatch-size'
    );

    label.innerHTML =
      label.dataset.productSwatchOriginalHtml ||
      escapeHtml(
        label.dataset.productSwatchOriginalValue ||
          optionValue ||
          ''
      );

    label.removeAttribute('aria-label');
    label.removeAttribute('title');
  };

  const upgradeLabels = ({
    root = document,
    productId = currentProductId,
    productHandle = currentProductHandle
  } = {}) => {
    const groups = getSwatches(
      productId,
      productHandle
    );

    if (!groups.length) return false;

    const labels = root.querySelectorAll(
      '[data-product-swatch-label]'
    );

    if (!labels.length) return false;

    labels.forEach((label) => {
      const optionName =
        label.getAttribute('data-option-name');

      const optionValue =
        label.getAttribute('data-option-value');

      if (!optionName || !optionValue) return;

      storeOriginalLabel(
        label,
        optionValue
      );

      const group = groups.find(
        (item) =>
          normalize(item.optionName) ===
          normalize(optionName)
      );

      if (!group) {
        if (
          label.dataset.productSwatchUpgraded ===
          'true'
        ) {
          restoreOriginalLabel(
            label,
            optionValue
          );
        }

        return;
      }

      const swatch = group.swatches.find(
        (item) =>
          normalize(item.label) ===
          normalize(optionValue)
      );

      if (
        !swatch ||
        (
          !swatch.image &&
          (
            !swatch.colors ||
            !swatch.colors.length
          )
        )
      ) {
        if (
          label.dataset.productSwatchUpgraded ===
          'true'
        ) {
          restoreOriginalLabel(
            label,
            optionValue
          );
        }

        return;
      }

      const safeOptionValue =
        escapeHtml(optionValue);

      label.dataset.productSwatchUpgraded =
        'true';

      label.classList.add(
        'product-form__swatch-label',
        'product-form__swatch-label--visual-only'
      );

      label.setAttribute(
        'aria-label',
        optionValue
      );

      label.setAttribute(
        'title',
        optionValue
      );

      label.style.setProperty(
        '--product-swatch-size',
        `${group.productSwatchSize}px`
      );

      if (swatch.image) {
        label.innerHTML = `
          <span
            class="
              product-form__swatch
              product-form__swatch--image
            "
            aria-hidden="true"
          >
            <img
              src="${swatch.image}"
              alt=""
              width="48"
              height="48"
              loading="eager"
            >
          </span>
          <span class="visually-hidden">
            ${safeOptionValue}
          </span>
        `;

        return;
      }

      if (swatch.style === 'conic') {
        label.innerHTML = `
          <span
            class="
              product-form__swatch
              product-form__swatch--color
              product-form__swatch--conic
            "
            style="
              --swatch-background:
              ${getColorBackground(
                swatch.colors,
                swatch.style
              )};
            "
            aria-hidden="true"
          ></span>
          <span class="visually-hidden">
            ${safeOptionValue}
          </span>
        `;

        return;
      }

      const segments = swatch.colors
        .map(
          (color) => `
            <span
              class="product-form__swatch-segment"
              style="background: ${color};"
            ></span>
          `
        )
        .join('');

      label.innerHTML = `
        <span
          class="
            product-form__swatch
            product-form__swatch--color
            product-form__swatch--line
          "
          aria-hidden="true"
        >
          ${segments}
        </span>
        <span class="visually-hidden">
          ${safeOptionValue}
        </span>
      `;
    });

    return true;
  };

  const getCardSwatchLimit = (card, list, swatchSize, optionCount) => {
    // The swatch element can become wider than its grid column when
    // its flex children impose an intrinsic minimum width. Measure
    // the actual card instead of the overflowing swatch row.
    const cardWidth =
      card.closest('.card')?.getBoundingClientRect().width ||
      card.closest('.card__content')?.getBoundingClientRect().width ||
      card.getBoundingClientRect().width;

    if (!cardWidth) return 5;

    const information = card.closest('.card__information');
    const informationStyle = information
      ? window.getComputedStyle(information)
      : null;
    const horizontalPadding = informationStyle
      ? (Number.parseFloat(informationStyle.paddingLeft) || 0) +
        (Number.parseFloat(informationStyle.paddingRight) || 0)
      : 0;
    const availableWidth = Math.max(0, cardWidth - horizontalPadding);

    const listStyle = window.getComputedStyle(list);
    const gap = Number.parseFloat(listStyle.columnGap) || 0;
    const footprint = swatchSize + gap;
    if (footprint <= 0) return 5;

    const maxVisible = 5;
    const capacityWithoutMore = Math.max(
      0,
      Math.floor((availableWidth + gap) / footprint)
    );

    // Only reserve space for +n when it is actually needed.
    if (optionCount <= Math.min(maxVisible, capacityWithoutMore)) {
      return Math.min(maxVisible, optionCount);
    }

    // Allow for '+14' (or similar) including its left margin and gap.
    const moreReserve = 42;
    return Math.max(
      1,
      Math.min(
        maxVisible,
        Math.floor((availableWidth - moreReserve + gap) / footprint)
      )
    );
  };

  const observedCardWidths = new Set();
  let cardWidthObserver = null;

  const observeCardSwatchWidths = () => {
    if (typeof ResizeObserver === 'undefined') return;

    if (!cardWidthObserver) {
      cardWidthObserver = new ResizeObserver(() => {
        if (resizeQueued) return;
        resizeQueued = true;
        requestAnimationFrame(() => {
          resizeQueued = false;
          renderCardSwatches();
        });
      });
    }

    // Clean up cards that were replaced during AJAX filtering/sorting.
    for (const target of observedCardWidths) {
      if (!target.isConnected) {
        cardWidthObserver.unobserve(target);
        observedCardWidths.delete(target);
      }
    }

    document.querySelectorAll('[data-card-product-swatches]').forEach((card) => {
      // Observe a stable card dimension, not the swatch row we render.
      const target =
        card.closest('.card')?.querySelector('.card__inner') ||
        card.closest('.card__content') ||
        card;

      if (!observedCardWidths.has(target)) {
        observedCardWidths.add(target);
        cardWidthObserver.observe(target);
      }
    });
  };

  const parseJsonScript = (
    root,
    selector,
    fallback = []
  ) => {
    const script = root.querySelector(selector);

    if (!script) return fallback;

    try {
      return JSON.parse(
        script.textContent || '[]'
      );
    } catch (error) {
      console.error(
        'Product card swatch JSON failed to parse:',
        error
      );

      return fallback;
    }
  };

  const getCardVariantForOption = (
    cardVariants,
    optionIndex,
    optionValue,
    preferredVariantId = ''
  ) => {
    if (
      !Array.isArray(cardVariants) ||
      optionIndex < 0
    ) {
      return null;
    }

    if (preferredVariantId) {
      const preferredVariant =
        cardVariants.find((variant) => {
          return (
            String(variant.id) ===
              String(preferredVariantId) &&
            normalize(
              variant.options &&
                variant.options[optionIndex]
            ) === normalize(optionValue)
          );
        });

      if (preferredVariant) {
        return preferredVariant;
      }
    }

    const availableMatch =
      cardVariants.find((variant) => {
        return (
          variant.available &&
          normalize(
            variant.options &&
              variant.options[optionIndex]
          ) === normalize(optionValue)
        );
      });

    if (availableMatch) {
      return availableMatch;
    }

    return (
      cardVariants.find((variant) => {
        return (
          normalize(
            variant.options &&
              variant.options[optionIndex]
          ) === normalize(optionValue)
        );
      }) ||
      null
    );
  };

  const getCardWrapper = (element) => {
    return element
      ? element.closest('.card-wrapper')
      : null;
  };

  const getCardMediaImage = (
    cardWrapper
  ) => {
    if (!cardWrapper) return null;

    return (
      cardWrapper.querySelector(
        '.card__media img.motion-reduce'
      ) ||
      cardWrapper.querySelector(
        '.card__media img'
      )
    );
  };

  const setCardSwatchHovering = (
    element,
    isHovering
  ) => {
    const cardWrapper =
      getCardWrapper(element);

    if (!cardWrapper) return;

    cardWrapper.classList.toggle(
      'card-swatches-hovering',
      isHovering
    );
  };

  const storeOriginalCardImage = (image) => {
    if (
      !image ||
      image.dataset.cardOriginalImageStored ===
        'true'
    ) {
      return;
    }

    image.dataset.cardOriginalImageStored =
      'true';

    image.dataset.cardOriginalSrc =
      image.getAttribute('src') || '';

    image.dataset.cardOriginalSrcset =
      image.getAttribute('srcset') || '';

    image.dataset.cardOriginalAlt =
      image.getAttribute('alt') || '';
  };

  const updateCardImageForVariant = (
    cardWrapper,
    variant
  ) => {
    const image =
      getCardMediaImage(cardWrapper);

    if (!image) return;

    storeOriginalCardImage(image);

    if (!variant || !variant.image) {
      if (image.dataset.cardOriginalSrc) {
        image.setAttribute(
          'src',
          image.dataset.cardOriginalSrc
        );
      }

      if (
        image.dataset.cardOriginalSrcset
      ) {
        image.setAttribute(
          'srcset',
          image.dataset.cardOriginalSrcset
        );
      }

      return;
    }

    image.setAttribute(
      'src',
      variant.image
    );

    if (variant.imageSrcset) {
      image.setAttribute(
        'srcset',
        variant.imageSrcset
      );

      // Keep lazy/responsive image attributes aligned with the split variant.
      if (image.hasAttribute('data-srcset')) {
        image.setAttribute('data-srcset', variant.imageSrcset);
      }
    } else {
      image.removeAttribute('srcset');
      if (image.hasAttribute('data-srcset')) {
        image.removeAttribute('data-srcset');
      }
    }
  };

  const previewCardImageForSwatch = (button) => {
    const cardWrapper = getCardWrapper(button);
    const image = getCardMediaImage(cardWrapper);

    if (!image) return;

    const variantImage = button.getAttribute('data-bentosmb-variant-image');
    const variantImageSrcset = button.getAttribute(
      'data-bentosmb-variant-image-srcset'
    );

    if (!variantImage) return;

    if (image.dataset.cardSwatchHoverStored !== 'true') {
      image.dataset.cardSwatchHoverStored = 'true';
      image.dataset.cardSwatchHoverSrc = image.getAttribute('src') || '';
      image.dataset.cardSwatchHoverSrcset =
        image.getAttribute('srcset') || '';
      image.dataset.cardSwatchHoverDataSrcset =
        image.getAttribute('data-srcset') || '';
      image.dataset.cardSwatchHoverHadSrcset =
        image.hasAttribute('srcset') ? 'true' : 'false';
      image.dataset.cardSwatchHoverHadDataSrcset =
        image.hasAttribute('data-srcset') ? 'true' : 'false';
    }

    image.setAttribute('src', variantImage);

    if (variantImageSrcset) {
      image.setAttribute('srcset', variantImageSrcset);

      if (image.hasAttribute('data-srcset')) {
        image.setAttribute('data-srcset', variantImageSrcset);
      }
    } else {
      image.removeAttribute('srcset');

      if (image.hasAttribute('data-srcset')) {
        image.removeAttribute('data-srcset');
      }
    }
  };

  const restoreCardImageAfterSwatchHover = (element) => {
    const cardWrapper = getCardWrapper(element);
    const image = getCardMediaImage(cardWrapper);

    if (!image || image.dataset.cardSwatchHoverStored !== 'true') {
      return;
    }

    if (image.dataset.cardSwatchHoverSrc) {
      image.setAttribute('src', image.dataset.cardSwatchHoverSrc);
    }

    if (image.dataset.cardSwatchHoverHadSrcset === 'true') {
      image.setAttribute(
        'srcset',
        image.dataset.cardSwatchHoverSrcset || ''
      );
    } else {
      image.removeAttribute('srcset');
    }

    if (image.dataset.cardSwatchHoverHadDataSrcset === 'true') {
      image.setAttribute(
        'data-srcset',
        image.dataset.cardSwatchHoverDataSrcset || ''
      );
    } else {
      image.removeAttribute('data-srcset');
    }

    delete image.dataset.cardSwatchHoverStored;
    delete image.dataset.cardSwatchHoverSrc;
    delete image.dataset.cardSwatchHoverSrcset;
    delete image.dataset.cardSwatchHoverDataSrcset;
    delete image.dataset.cardSwatchHoverHadSrcset;
    delete image.dataset.cardSwatchHoverHadDataSrcset;
  };

  const getCardTitleLink = (cardWrapper) => {
    if (!cardWrapper) return null;

    return (
      cardWrapper.querySelector(
        '.card__content .card__heading a[href*="/products/"]'
      ) ||
      cardWrapper.querySelector(
        'a[id^="CardLink-"]'
      ) ||
      cardWrapper.querySelector(
        'a[id^="StandardCardNoMediaLink-"]'
      )
    );
  };

  const previewCardTitleForSwatch = (button) => {
    const cardWrapper = getCardWrapper(button);
    const titleLink = getCardTitleLink(cardWrapper);

    const hoveredLabel = String(
      button.getAttribute('aria-label') ||
      button.getAttribute('title') ||
      ''
    ).trim();

    if (!titleLink || !hoveredLabel) return;

    if (titleLink.dataset.cardSwatchHoverTitleStored !== 'true') {
      const originalTitle = titleLink.textContent.trim();

      const activeButton = cardWrapper.querySelector(
        '[data-card-product-swatch-button].is-active'
      );

      const activeLabel = String(
        activeButton?.getAttribute('aria-label') ||
        activeButton?.getAttribute('title') ||
        ''
      ).trim();

      let baseTitle = originalTitle;

      if (activeLabel) {
        const activeSuffix = ` - ${activeLabel}`;

        if (
          normalize(originalTitle).endsWith(
            normalize(activeSuffix)
          )
        ) {
          baseTitle = originalTitle
            .slice(0, -activeSuffix.length)
            .trim();
        }
      }

      titleLink.dataset.cardSwatchHoverTitleStored = 'true';
      titleLink.dataset.cardSwatchHoverOriginalHtml =
        titleLink.innerHTML;
      titleLink.dataset.cardSwatchHoverBaseTitle = baseTitle;
    }

    const baseTitle =
      titleLink.dataset.cardSwatchHoverBaseTitle || '';

    titleLink.textContent = baseTitle
      ? `${baseTitle} - ${hoveredLabel}`
      : hoveredLabel;
  };

  const restoreCardTitleAfterSwatchHover = (element) => {
    const cardWrapper = getCardWrapper(element);
    const titleLink = getCardTitleLink(cardWrapper);

    if (
      !titleLink ||
      titleLink.dataset.cardSwatchHoverTitleStored !== 'true'
    ) {
      return;
    }

    titleLink.innerHTML =
      titleLink.dataset.cardSwatchHoverOriginalHtml || '';

    delete titleLink.dataset.cardSwatchHoverTitleStored;
    delete titleLink.dataset.cardSwatchHoverOriginalHtml;
    delete titleLink.dataset.cardSwatchHoverBaseTitle;
  };

  const updateCardProductLinks = (
    cardWrapper,
    variantUrl
  ) => {
    if (!cardWrapper || !variantUrl) return;

    cardWrapper
      .querySelectorAll('a[href]')
      .forEach((link) => {
        const href =
          link.getAttribute('href') || '';

        if (
          link.matches(
            '.card-product-swatches__more'
          )
        ) {
          return;
        }

        if (
          href.includes('/products/') ||
          link.classList.contains(
            'full-unstyled-link'
          ) ||
          link.id.startsWith('CardLink-') ||
          link.id.startsWith(
            'StandardCardNoMediaLink-'
          )
        ) {
          link.setAttribute(
            'href',
            variantUrl
          );
        }
      });
    }
    
  const getAssignedCardVariantId = (element) => {
    // The split-variant app owns the assigned card variant. Its ID is on
    // the outer <li>; our previously stored ID may be on .card-wrapper.
    const splitCard = element.closest(
      '[data-eosh-variant-id], [swatch-default-variant]'
    );
    const cardWrapper = getCardWrapper(element);

    const variantId = String(
      splitCard?.getAttribute('data-eosh-variant-id') ||
        splitCard?.getAttribute('swatch-default-variant') ||
        cardWrapper?.getAttribute('data-bentosmb-card-variant-id') ||
        ''
    ).trim();

    if (cardWrapper && variantId) {
      if (
        cardWrapper.getAttribute('data-bentosmb-card-variant-id') !==
        variantId
      ) {
        cardWrapper.setAttribute('data-bentosmb-card-variant-id', variantId);
      }

      // Keep existing theme/app code that reads this field in sync, too.
      if (
        splitCard &&
        cardWrapper.getAttribute('data-selected-variant-id') !== variantId
      ) {
        cardWrapper.setAttribute('data-selected-variant-id', variantId);
      }
    }

    return variantId;
  };

  const addVariantToProductUrl = (href, variantId) => {
    if (!href || !variantId) return href;

    try {
      const url = new URL(href, window.location.origin);

      url.searchParams.set('variant', variantId);

      return `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
      return href;
    }
  };

  const syncCardVariantLinks = (root = document) => {
    const cards =
      root instanceof Element &&
      root.matches('[data-card-product-swatches]')
        ? [root]
        : root.querySelectorAll('[data-card-product-swatches]');

    cards.forEach((card) => {
      const cardWrapper = getCardWrapper(card);
      const variantId = getAssignedCardVariantId(card);

      if (!cardWrapper || !variantId) return;

      cardWrapper
        .querySelectorAll('a[href*="/products/"]')
        .forEach((link) => {
          const href = link.getAttribute('href') || '';

          link.setAttribute(
            'href',
            addVariantToProductUrl(href, variantId)
          );
        });

      cardWrapper
          .querySelectorAll('button[data-product-url*="/products/"]')
          .forEach((link) => {
            const url = link.getAttribute('data-product-url') || '';

            link.setAttribute(
                'data-product-url',
                addVariantToProductUrl(url, variantId)
            );
          });
    });
  };

  const selectCardSwatch = (button) => {
    const card = button.closest(
      '[data-card-product-swatches]'
    );

    const cardWrapper =
      getCardWrapper(button);

    if (!card || !cardWrapper) return;

    cardWrapper.classList.add(
      'card-swatches-hovering'
    );

    window.setTimeout(() => {
      if (!card.matches(':hover')) {
        cardWrapper.classList.remove(
          'card-swatches-hovering'
        );
      }
    }, 250);

    const variantId =
      button.getAttribute('data-bentosmb-variant-id');

    const variantUrl =
      button.getAttribute('data-bentosmb-variant-url');

    const variantImage =
      button.getAttribute(
        'data-bentosmb-variant-image'
      );

    const variantImageSrcset =
      button.getAttribute(
        'data-bentosmb-variant-image-srcset'
      );

    card
      .querySelectorAll(
        '.card-product-swatches__item.is-active'
      )
      .forEach((item) => {
        item.classList.remove('is-active');

        item.setAttribute(
          'aria-pressed',
          'false'
        );
      });

    button.classList.add('is-active');

    button.setAttribute(
      'aria-pressed',
      'true'
    );

    const variant = variantId
      ? {
          id: variantId,
          url: variantUrl,
          image: variantImage || null,
          imageSrcset:
            variantImageSrcset || null
        }
      : null;

    updateCardImageForVariant(
      cardWrapper,
      variant
    );

    updateCardProductLinks(
      cardWrapper,
      variantUrl
    );
  };

  const renderSwatchHtml = (swatch) => {
    if (!swatch) return '';

    if (swatch.image) {
      return `
        <span
          class="
            product-form__swatch
            product-form__swatch--image
          "
          aria-hidden="true"
        >
          <img
            src="${swatch.image}"
            alt=""
            width="48"
            height="48"
            loading="lazy"
          >
        </span>
      `;
    }

    if (swatch.style === 'conic') {
      return `
        <span
          class="
            product-form__swatch
            product-form__swatch--color
            product-form__swatch--conic
          "
          style="
            --swatch-background:
            ${getColorBackground(
              swatch.colors,
              swatch.style
            )};
          "
          aria-hidden="true"
        ></span>
      `;
    }

    const segments = swatch.colors
      .map(
        (color) => `
          <span
            class="product-form__swatch-segment"
            style="background: ${color};"
          ></span>
        `
      )
      .join('');

    return `
      <span
        class="
          product-form__swatch
          product-form__swatch--color
          product-form__swatch--line
        "
        aria-hidden="true"
      >
        ${segments}
      </span>
    `;
  };

  const renderCardSwatches = () => {
    const cards = document.querySelectorAll(
      '[data-card-product-swatches]'
    );

    if (!cards.length) return false;

    cards.forEach((card) => {
      const productId =
        card.getAttribute('data-product-id');

      const productHandle =
        card.getAttribute(
          'data-product-handle'
        );

      const productUrl =
        card.getAttribute(
          'data-product-url'
        ) || '#';

      const list = card.querySelector(
        '[data-card-product-swatches-list]'
      );

      if (
        !productId ||
        !productHandle ||
        !list
      ) {
        return;
      }

      const cardOptions = parseJsonScript(
        card,
        '[data-card-product-swatches-options]'
      );

      const cardVariants = parseJsonScript(
        card,
        '[data-card-product-swatches-variants]'
      );

      const selectedVariantId = getAssignedCardVariantId(card);

      const selectedVariant =
        selectedVariantId
          ? cardVariants.find(
              (variant) =>
                String(variant.id) ===
                selectedVariantId
            ) || null
          : null;

      const cardDestinationUrl =
        selectedVariant?.url || productUrl;

      const groups = getSwatches(
        productId,
        productHandle
      ).filter(
        (group) => group.showOnCard
      );

      const collectionSwatchSize =
        groups.length > 0
          ? groups[0].collectionSwatchSize
          : 34;

      card.style.setProperty(
        '--card-product-swatch-size',
        `${collectionSwatchSize}px`
      );

      const optionCount = groups.reduce((count, group) => {
        const option = cardOptions.find(
          (entry) => normalize(entry.name) === normalize(group.optionName)
        );
        if (!option) return count;
        return count + (option.values || []).filter((value) =>
          group.swatches.some((swatch) =>
            normalize(swatch.label) === normalize(value) &&
            (swatch.image || (swatch.colors && swatch.colors.length))
          )
        ).length;
      }, 0);

      const limit = getCardSwatchLimit(
        card,
        list,
        collectionSwatchSize,
        optionCount
      );

      const rendered = [];
      let candidateCount = 0;

      groups.forEach((group) => {
        const cardOptionIndex =
          cardOptions.findIndex((option) => {
            return (
              normalize(option.name) ===
              normalize(group.optionName)
            );
          });

        if (cardOptionIndex < 0) return;

        const values =
          cardOptions[cardOptionIndex]
            .values || [];

        const selectedOptionValue =
          selectedVariant &&
          Array.isArray(
            selectedVariant.options
          )
            ? selectedVariant.options[
                cardOptionIndex
              ]
            : '';

        const orderedValues =
          selectedOptionValue
            ? [
                selectedOptionValue,
                ...values.filter(
                  (value) =>
                    normalize(value) !==
                    normalize(
                      selectedOptionValue
                    )
                )
              ]
            : values;

        orderedValues.forEach(
          (optionValue) => {
            candidateCount += 1;

            const swatch =
              group.swatches.find(
                (item) =>
                  normalize(item.label) ===
                  normalize(optionValue)
              );

            if (
              !swatch ||
              (
                !swatch.image &&
                (
                  !swatch.colors ||
                  !swatch.colors.length
                )
              )
            ) {
              return;
            }

            if (
              rendered.length >= limit
            ) {
              return;
            }

            const isSelectedOption =
              selectedVariant &&
              normalize(
                selectedVariant.options &&
                  selectedVariant.options[
                    cardOptionIndex
                  ]
              ) === normalize(optionValue);

            const variant =
              getCardVariantForOption(
                cardVariants,
                cardOptionIndex,
                optionValue,
                isSelectedOption
                  ? selectedVariantId
                  : ''
              );

            const activeClass =
              isSelectedOption ||
              (
                !selectedVariant &&
                rendered.length === 0
              )
                ? ' is-active'
                : '';

            rendered.push(`
              <button
                type="button"
                class="
                  card-product-swatches__item
                  ${activeClass}
                "
                data-card-product-swatch-button
                data-bentosmb-variant-id="${
                  variant && variant.id
                    ? escapeHtml(variant.id)
                    : ''
                }"
                data-bentosmb-variant-url="${
                  variant && variant.url
                    ? escapeHtml(variant.url)
                    : escapeHtml(productUrl)
                }"
                data-bentosmb-variant-image="${
                  variant && variant.image
                    ? escapeHtml(variant.image)
                    : ''
                }"
                data-bentosmb-variant-image-srcset="${
                  variant &&
                  variant.imageSrcset
                    ? escapeHtml(
                        variant.imageSrcset
                      )
                    : ''
                }"
                aria-label="${escapeHtml(
                  optionValue
                )}"
                aria-pressed="${
                  activeClass
                    ? 'true'
                    : 'false'
                }"
                title="${escapeHtml(
                  optionValue
                )}"
              >
                ${renderSwatchHtml(swatch)}
                <span class="visually-hidden">
                  ${escapeHtml(optionValue)}
                </span>
              </button>
            `);
          }
        );
      });

      const remainder = Math.max(
        0,
        candidateCount - rendered.length
      );

      if (!rendered.length) {
        list.innerHTML = '';

        card.setAttribute(
          'data-card-product-swatches-empty',
          'true'
        );

        return;
      }

      card.removeAttribute(
        'data-card-product-swatches-empty'
      );

      list.innerHTML = `
        ${rendered.join('')}
        ${
          remainder > 0
            ? `
              <a
                class="card-product-swatches__more"
                href="${escapeHtml(cardDestinationUrl)}"
                aria-label="${remainder} more options"
              >
                +${remainder}
              </a>
            `
            : ''
        }
      `;

      const selectedButton =
        list.querySelector(
          '[data-card-product-swatch-button].is-active'
        );

      if (
        selectedButton &&
        selectedVariant
      ) {
        selectCardSwatch(
          selectedButton
        );
      }

      syncCardVariantLinks(card);
    });

    observeCardSwatchWidths();
    return true;
  };

  const retryRenderCardSwatches = () => {
    let attempts = 0;
    const maxAttempts = 30;

    const retry = () => {
      attempts += 1;

      if (
        renderCardSwatches() ||
        attempts >= maxAttempts
      ) {
        return;
      }

      requestAnimationFrame(retry);
    };

    requestAnimationFrame(retry);
  };

  let eoshObserverStarted = false;
  let eoshRefreshTimer = null;

  const scheduleEoshSwatchRefresh = () => {
    window.clearTimeout(eoshRefreshTimer);
    eoshRefreshTimer = window.setTimeout(() => {
      renderCardSwatches();
      observeQuickAddModals();
    }, 100);
  };

  const observeEoshVariantCards = () => {
    if (eoshObserverStarted || !document.body) return;

    eoshObserverStarted = true;

    // Watch for new product grids/cards, not our injected swatch buttons.
    // Shopify AJAX filters and sorting can replace #product-grid entirely.
    const gridOrCardSelector = [
      '#product-grid',
      '#ProductGridContainer',
      'li.grid__item',
      '[data-eosh-variant-id]',
      '[data-card-product-swatches]'
    ].join(', ');

    const observer = new MutationObserver((mutations) => {
      const cardsChanged = mutations.some((mutation) => {
        if (mutation.type === 'attributes') {
          return (
            mutation.attributeName === 'data-eosh-variant-id' ||
            mutation.attributeName === 'swatch-default-variant'
          );
        }

        return Array.from(mutation.addedNodes).some((node) => {
          if (!(node instanceof Element)) return false;
          return (
            node.matches(gridOrCardSelector) ||
            Boolean(node.querySelector(gridOrCardSelector))
          );
        });
      });

      if (cardsChanged) scheduleEoshSwatchRefresh();
    });

    // document.body survives replacement of Shopify's AJAX product grid.
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'data-eosh-variant-id',
        'swatch-default-variant'
      ]
    });
  };

  const refreshAllSwatches = () => {
    if (!refreshSectionReference()) return;

    refreshActiveGroups();
    upgradeLabels();
    scheduleProductTitleUpdate();

    if (!renderCardSwatches()) {
      retryRenderCardSwatches();
    }

    observeEoshVariantCards();
  };

  const scheduleCustomizerReapply = () => {
    if (!isDesignMode) return;
    if (customizerReapplyQueued) return;

    customizerReapplyQueued = true;
    hidePreview();

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        customizerReapplyQueued = false;
        refreshAllSwatches();
      });
    });
  };

  refreshActiveGroups();
  scheduleProductTitleUpdate();

  if (!upgradeLabels()) {
    let attempts = 0;
    const maxAttempts = 20;

    const retry = () => {
      attempts += 1;

      if (upgradeLabels()) {
        scheduleProductTitleUpdate();
        renderCardSwatches();
        return;
      }

      if (attempts >= maxAttempts) {
        return;
      }

      requestAnimationFrame(retry);
    };

    requestAnimationFrame(retry);
  }

  if (!renderCardSwatches()) {
    retryRenderCardSwatches();
  }

  observeEoshVariantCards();

  const prepareCardVariantLink = (event) => {
    if (!(event.target instanceof Element)) return;

    const productLink = event.target.closest(
      '.card-wrapper a[href*="/products/"]'
    );

    if (!productLink) return;

    const card = productLink
      .closest('.card-wrapper')
      ?.querySelector('[data-card-product-swatches]');

    if (!card) return;

    syncCardVariantLinks(card);
  };

  document.addEventListener(
    'pointerdown',
    prepareCardVariantLink,
    true
  );

  document.addEventListener(
    'click',
    prepareCardVariantLink,
    true
  );

  window.addEventListener('pageshow', () => {
    requestAnimationFrame(() => {
      syncCardVariantLinks();
    });

    window.setTimeout(() => {
      syncCardVariantLinks();
    }, 150);
  });

  document.addEventListener(
    'mouseover',
    (event) => {
      const label = event.target.closest(
        '[data-product-swatch-label]'
      );

      if (!label) return;

      const { group, swatch } =
        getGroupAndSwatchForLabel(label);

      if (
        !group ||
        (
          !group.rolloverPreview &&
          !group.labelPopup &&
          !group.swatchPreview
        )
      ) {
        return;
      }

      showPreview(
        label,
        getPreviewOptions(
          label,
          group,
          swatch
        )
      );
    }
  );

  document.addEventListener(
    'focusin',
    (event) => {
      const label = event.target.closest(
        '[data-product-swatch-label]'
      );

      if (!label) return;

      const { group, swatch } =
        getGroupAndSwatchForLabel(label);

      if (
        !group ||
        (
          !group.rolloverPreview &&
          !group.labelPopup &&
          !group.swatchPreview
        )
      ) {
        return;
      }

      showPreview(
        label,
        getPreviewOptions(
          label,
          group,
          swatch
        )
      );
    }
  );

  document.addEventListener(
    'mouseout',
    (event) => {
      const label = event.target.closest(
        '[data-product-swatch-label]'
      );

      if (!label) return;

      if (
        event.relatedTarget &&
        label.contains(event.relatedTarget)
      ) {
        return;
      }

      hidePreview();
    }
  );

  document.addEventListener(
    'focusout',
    (event) => {
      const label = event.target.closest(
        '[data-product-swatch-label]'
      );

      if (!label) return;

      hidePreview();
    }
  );

  const stopCardSwatchNavigation = (
    event
  ) => {
    const button = event.target.closest(
      '[data-card-product-swatch-button]'
    );

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (
      typeof event.stopImmediatePropagation ===
      'function'
    ) {
      event.stopImmediatePropagation();
    }
  };

  document.addEventListener(
    'pointerdown',
    stopCardSwatchNavigation,
    true
  );

  document.addEventListener(
    'mousedown',
    stopCardSwatchNavigation,
    true
  );

  document.addEventListener(
    'touchstart',
    stopCardSwatchNavigation,
    true
  );

  document.addEventListener('pointerover', (event) => {
    const button = event.target.closest(
      '[data-card-product-swatch-button]'
    );

    if (
      button &&
      (!event.relatedTarget || !button.contains(event.relatedTarget))
    ) {
      previewCardImageForSwatch(button);
      previewCardTitleForSwatch(button);
    }

    const swatchArea = event.target.closest(
      '[data-card-product-swatches]'
    );

    if (!swatchArea) return;

    setCardSwatchHovering(swatchArea, true);
  });

  document.addEventListener('pointerout', (event) => {
    const button = event.target.closest(
      '[data-card-product-swatch-button]'
    );

    if (
      button &&
      (!event.relatedTarget || !button.contains(event.relatedTarget))
    ) {
      restoreCardImageAfterSwatchHover(button);
      restoreCardTitleAfterSwatchHover(button);
    }

    const swatchArea = event.target.closest(
      '[data-card-product-swatches]'
    );

    if (!swatchArea) return;

    if (
      event.relatedTarget &&
      swatchArea.contains(event.relatedTarget)
    ) {
      return;
    }

    setCardSwatchHovering(swatchArea, false);
  });

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(
        '[data-card-product-swatch-button]'
      );

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      if (
        typeof event.stopImmediatePropagation ===
        'function'
      ) {
        event.stopImmediatePropagation();
      }

      const variantUrl =
        button.getAttribute(
          'data-bentosmb-variant-url'
        );

      if (!variantUrl) return;

      window.location.assign(variantUrl);
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;

      if (
        !(
          input instanceof
          HTMLInputElement
        )
      ) {
        return;
      }

      if (
        !input.matches(
          'input[type="radio"]'
        )
      ) {
        return;
      }

      const fieldset =
        input.closest('fieldset');

      if (
        !fieldset ||
        !fieldset.querySelector(
          '[data-product-swatch-label]'
        )
      ) {
        return;
      }

      scheduleProductTitleUpdate();
    }
  );

  document.addEventListener(
    'click',
    (event) => {
      const label = event.target.closest(
        '[data-product-swatch-label]'
      );

      if (!label) return;

      hidePreview();
      scheduleProductTitleUpdate();
    }
  );

  document.addEventListener(
    'scroll',
    hidePreview,
    {
      passive: true
    }
  );

  window.addEventListener(
    'resize',
    () => {
      hidePreview();

      if (resizeQueued) return;

      resizeQueued = true;

      requestAnimationFrame(() => {
        resizeQueued = false;

        // The viewport breakpoint may not change even though the
        // actual card width does (theme editor, carousels, sidebars).
        renderCardSwatches();
      });
    }
  );

 const applyQuickAddSwatches = (
  quickAddModal
) => {
  if (!quickAddModal) return;

  if (
    quickAddModal.dataset
      .productSwatchApplyQueued === 'true'
  ) {
    return;
  }

  const root =
    quickAddModal.querySelector(
      '.quick-add-modal__content-info'
    );

  if (!root) return;

  quickAddModal.dataset
    .productSwatchApplyQueued = 'true';

  const cardWrapper =
    quickAddModal.closest(
      '.card-wrapper, li, .grid__item'
    );

  const cardSwatches =
    cardWrapper?.querySelector(
      '[data-card-product-swatches]'
    );

  const productId = String(
    cardSwatches?.getAttribute(
      'data-product-id'
    ) || ''
  ).trim();

  const productHandle = String(
    cardSwatches?.getAttribute(
      'data-product-handle'
    ) || ''
  ).trim();

  if (productId) {
    quickAddModal.setAttribute(
      'data-product-swatch-product-id',
      productId
    );
  }

  if (productHandle) {
    quickAddModal.setAttribute(
      'data-product-swatch-product-handle',
      productHandle
    );
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      quickAddModal.dataset
        .productSwatchApplyQueued = 'false';

      upgradeLabels({
        root,
        productId,
        productHandle
      });

      scheduleProductTitleUpdate();
    });
  });
};

const observeQuickAddModal = (
  quickAddModal
) => {
  if (
    !quickAddModal ||
    quickAddModal.dataset
      .productSwatchObserverStarted === 'true'
  ) {
    return;
  }

  const content =
    quickAddModal.querySelector(
      '.quick-add-modal__content-info'
    );

  if (!content) return;

  quickAddModal.dataset
    .productSwatchObserverStarted = 'true';

  const observer =
    new MutationObserver(
      (mutations) => {
        const productMarkupAdded =
          mutations.some(
            (mutation) => {
              return Array.from(
                mutation.addedNodes
              ).some((node) => {
                if (
                  !(node instanceof Element)
                ) {
                  return false;
                }

                return (
                  node.matches(
                    'variant-radios'
                  ) ||
                  Boolean(
                    node.querySelector(
                      'variant-radios'
                    )
                  )
                );
              });
            }
          );

        if (!productMarkupAdded) {
          return;
        }

        applyQuickAddSwatches(
          quickAddModal
        );
      }
    );

  observer.observe(content, {
    childList: true,
    subtree: true
  });

  /*
   * Handle a modal whose product content
   * was already loaded before this observer
   * was attached.
   */
  if (
    content.querySelector(
      'variant-radios'
    )
  ) {
    applyQuickAddSwatches(
      quickAddModal
    );
  }
};

const observeQuickAddModals = (
  root = document
) => {
  if (
    root instanceof Element &&
    root.matches('quick-add-modal')
  ) {
    observeQuickAddModal(root);
  }

  root
    .querySelectorAll?.(
      'quick-add-modal'
    )
    .forEach(
      observeQuickAddModal
    );
};

observeQuickAddModals();
  
  if (isDesignMode) {
    document.addEventListener(
      'shopify:section:load',
      () => {
        refreshSectionReference();
        scheduleCustomizerReapply();
      }
    );

    document.addEventListener(
      'shopify:section:select',
      scheduleCustomizerReapply
    );

    document.addEventListener(
      'shopify:section:deselect',
      scheduleCustomizerReapply
    );

    document.addEventListener(
      'shopify:section:reorder',
      scheduleCustomizerReapply
    );

    document.addEventListener(
      'shopify:block:select',
      scheduleCustomizerReapply
    );

    document.addEventListener(
      'shopify:block:deselect',
      scheduleCustomizerReapply
    );

    document.addEventListener(
      'shopify:block:reorder',
      scheduleCustomizerReapply
    );

    const observer = new MutationObserver(
      scheduleCustomizerReapply
    );

    observer.observe(section, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'data-option-name',
        'data-rollover-preview',
        'data-label-popup',
        'data-swatch-preview',
        'data-show-on-card',
        'data-product-swatch-size',
        'data-collection-swatch-size',
        'data-option-value',
        'data-swatch-style',
        'data-product-rule',
        'data-product-ids',
        'data-product-handles',
        'data-swatch-color-1',
        'data-swatch-color-2',
        'data-swatch-color-3',
        'data-swatch-color-4',
        'data-swatch-color-5',
        'data-swatch-image'
      ]
    });
  }

  return true;
};

const bootProductSwatches = () => {
  if (startProductSwatches()) return;

  let attempts = 0;
  const maxAttempts = 30;

  const retry = () => {
    attempts += 1;

    if (
      startProductSwatches() ||
      attempts >= maxAttempts
    ) {
      return;
    }

    requestAnimationFrame(retry);
  };

  requestAnimationFrame(retry);
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    bootProductSwatches,
    {
      once: true
    }
  );
} else {
  bootProductSwatches();
}